import { Text } from 'components'
import dayjs from 'dayjs'
import { startCase } from 'lodash-es'
import { useBreakpoint } from 'utils'
import { dateFromExcel } from 'utils/tableUtils'
import Flex from './Flex'
import Menu from './Menu'
import SimpleGrid from './SimpleGrid'
import { ArrowLongLeftIcon, XMarkIcon } from './icons'

interface Props {
  referenceField: string
  targetFieldsAndValues: Record<string, string>
  error?: boolean
  onChange: (val: string) => void
  value?: string
}

export default function FieldMapper({
  referenceField,
  targetFieldsAndValues,
  error,
  onChange,
  value,
}: Props) {
  const isMobile = useBreakpoint() < 2
  let outputValue = targetFieldsAndValues[value || '']
  if (outputValue && dateColumns.includes(referenceField))
    outputValue = dayjs(dateFromExcel(outputValue)).format('M/D/YYYY h:mm A')

  return (
    <SimpleGrid w="100%" columns={3} gap={3}>
      <Flex gap={3} justify="space-between" align="center">
        <Text {...textProps} w="100%">
          {startCase(referenceField)}
        </Text>
        {!isMobile && <ArrowLongLeftIcon transform="rotateY(180deg)" />}
      </Flex>
      <Menu
        border={error ? '1px solid red' : '1px solid rgba(23, 23, 23, 0.20)'}
        hideCheckbox
        value={value}
        menuProps={{ closeOnSelect: true, positioning: { sameWidth: true } }}
        buttonLabel={startCase(value)}
        onChange={onChange}
        options={[
          ...(value !== ''
            ? [
                {
                  type: 'item' as const,
                  value: '',
                  label: (
                    <Flex gap={1} align="center">
                      <XMarkIcon color="red" fontSize="md" />
                      <Text textStyle="bodySmall" color="red" fontWeight="500" as="i">
                        Clear
                      </Text>
                    </Flex>
                  ),
                },
              ]
            : []),
          ...Object.keys(targetFieldsAndValues).map(value => ({ value })),
        ]}
        {...menuStyling}
      />
      <Text {...textProps}>{outputValue}</Text>
    </SimpleGrid>
  )
}

const dateColumns = ['created', 'updated']

const textProps = {
  bg: 'rgba(23, 23, 23, 0.10)',
  borderRadius: '10px',
  minW: '100px',
  h: '40px',
  py: '10px',
  px: '16px',
  textStyle: 'bodyMedium',
  fontWeight: '500',
  truncate: true,
}

const menuStyling = {
  minW: '100px',
  borderRadius: '10px',
  textStyle: 'bodyLarge',
  fontWeight: '500',
}
